import {
    Create,
    Datagrid,
    DeleteButton,
    Edit,
    List,
    NumberField,
    required,
    Show,
    ShowButton,
    SimpleForm,
    SimpleShowLayout,
    TextField,
    TextInput,
    NumberInput
} from 'react-admin'
import DateTimeField from "../Components/Fields/DateTimeField";
import ListActions from "../Components/Toolbars/TopToolbars/ListActions";
import ShowActions from "../Components/Toolbars/TopToolbars/ShowActions";
import EditActions from "../Components/Toolbars/TopToolbars/EditActions";
import CreateActions from "../Components/Toolbars/TopToolbars/CreateActions";
import CreateToolbar from "../Components/Toolbars/BottomToolbars/CreateToolbar";
import Aside from "../Components/Aside";
import CompanyField from "../Components/Fields/CompanyField";
import CompanyInput from "../Components/Inputs/CompanyInput";

const Title = ({record}) => {
    return <span>{record ? `#${record.uid}: ${record.firstName} ${record.lastName}` : ''}</span>;
};

export const CustomerList = (props) => (
    <List
        title="ra.page.customers"
        sort={{ field: 'updatedAt', order: 'DESC' }}
        aside={<Aside filters={{
            id: 'live',
            email: 'live',
            telephone: "live",
            firstName: 'live',
            lastName: 'live',
            createdAt: 'dateRange'
        }}/>} {...props} actions={<ListActions/>}>
        <Datagrid rowClick="edit">

            <NumberField label="#" source="originId" sortBy={'id'}/>

            <TextField label="ra.field.email" source={'email'}/>
            <TextField label="ra.field.firstName" source={'firstName'}/>
            <TextField label="ra.field.lastName" source={'lastName'}/>

            <TextField label="ra.field.telephone" source={'telephone'}/>

            <NumberField label="ra.field.loyalty" source={'startLoyalty'}/>

            <CompanyField label="ra.field.company"/>

            <DateTimeField label="ra.field.createdAt" source={'createdAt'}/>

            <DateTimeField label="ra.field.updatedAt" source={'updatedAt'}/>

            <ShowButton/>
            <DeleteButton/>

        </Datagrid>
    </List>
)

export const CustomerShow = (props) => (
    <Show actions={<ShowActions/>} title={<Title/>} {...props}>
        <SimpleShowLayout>

            <TextField label="ra.field.email" source={'email'}/>
            <TextField label="ra.field.firstName" source={'firstName'}/>
            <TextField label="ra.field.lastName" source={'lastName'}/>

            <TextField label="ra.field.telephone" source={'telephone'}/>
            <NumberField label="ra.field.loyalty" source={'startLoyalty'}/>

            <TextField label="ra.field.company"/>
            <CompanyField/>

            <TextField label="ra.field.createdAt"/>
            <DateTimeField label="ra.field.createdAt" source={'createdAt'}/>

            <TextField label="ra.field.updatedAt"/>
            <DateTimeField label="ra.field.updatedAt" source={'updatedAt'}/>

        </SimpleShowLayout>
    </Show>
)

export const CustomerEdit = (props) => (
    <Edit actions={<EditActions/>} title={<Title/>} {...props}>
        <SimpleForm>

            <TextInput label="ra.field.email" source="email"/>
            <TextInput label="ra.field.firstName" source="firstName"/>
            <TextInput label="ra.field.lastName" source="lastName"/>

            <TextInput label="ra.field.telephone" source="telephone"/>

            <NumberInput label="ra.field.loyalty" source="startLoyalty"/>

            <CompanyInput label="ra.field.company"/>

        </SimpleForm>
    </Edit>
)

export const CustomerCreate = (props) => (
    <Create actions={<CreateActions/>} {...props}>
        <SimpleForm toolbar={<CreateToolbar/>}>

            <TextInput label="ra.field.email" source="email"/>
            <TextInput label="ra.field.firstName" source="firstName" validate={required()}/>
            <TextInput label="ra.field.lastName" source="lastName" validate={required()}/>

            <TextInput label="ra.field.telephone" source="telephone" validate={required()}/>

            <CompanyInput label="ra.field.company"/>

        </SimpleForm>
    </Create>
);
